import { DeletePlayerInput3nqh5he11jo1p as DeletePlayerInput } from './schema/type/DeletePlayerInput.mjs';
import { DeletePlayerMutation1lewkfyyqx4x0 as DeletePlayerMutation } from './schema/DeletePlayerMutation.mjs';
import { voidResult3hb4jxf0f2mcw as voidResult } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/VoidResult.mjs';
import { Unauthorized_instance3p96f1r9ta19w as Unauthorized_instance } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/CommandResult.mjs';
import { Dispatcher1dgi8c7arrsv1 as Dispatcher } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/player/DeletePlayerCommand.mjs';
import { GqlTrait2wtoeyl3yfalb as GqlTrait } from './gql/GqlTrait.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *perform(command, $completion) {
  // Inline function 'kotlin.with' call
  var tmp0_safe_receiver = (yield* this.v75(new (DeletePlayerMutation())(new (DeletePlayerInput())(command.a2m_1, command.b2m_1)), $completion)).b46_1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x6q_1;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : voidResult(tmp1_safe_receiver);
  return tmp2_elvis_lhs == null ? Unauthorized_instance : tmp2_elvis_lhs;
}
var SdkDeletePlayerCommandDispatcherClass;
function SdkDeletePlayerCommandDispatcher() {
  if (SdkDeletePlayerCommandDispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SdkDeletePlayerCommandDispatcher', VOID, VOID, [Dispatcher(), GqlTrait()], [1]);
    SdkDeletePlayerCommandDispatcherClass = $;
  }
  return SdkDeletePlayerCommandDispatcherClass;
}
//region block: exports
export {
  SdkDeletePlayerCommandDispatcher as SdkDeletePlayerCommandDispatcher2rxhmptx7gljw,
  perform as perform3ecdiayucun80,
};
//endregion

//# sourceMappingURL=SdkDeletePlayerCommandDispatcher.mjs.map
